import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "font-weight-bold mr-1"
};
import { ref, watch } from 'vue';
import LlTooltip from '@/components/LlTooltip.vue';
export default {
  __name: 'LlSelect',
  props: {
    modelValue: {
      type: [Object, String, Number],
      required: false
    },
    items: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    itemTitle: {
      type: [String, Function],
      default: 'label'
    },
    itemValue: {
      type: String,
      default: 'id'
    },
    itemProps: {
      type: [Function, Object, String],
      required: false
    },
    menuProps: {
      type: Object,
      required: false
    },
    density: {
      type: String,
      default: 'compact'
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    variant: {
      type: String,
      default: 'outlined'
    },
    componentClass: {
      type: String,
      default: 'remove-outline'
    },
    placeholder: {
      type: String,
      default: ''
    },
    hideDetails: {
      type: [Boolean, String],
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isAutocomplete: {
      type: Boolean,
      default: false
    },
    labelClass: {
      type: String,
      default: 'text-sm'
    },
    info: {
      type: String,
      default: ''
    },
    showInfo: {
      type: Boolean,
      default: true
    },
    selectClass: {
      type: String,
      default: ''
    },
    invalid: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    },
    dataCy: {
      type: String,
      default: ''
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: ''
    },
    persistentHint: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const internalValue = ref(props.modelValue);
    watch(() => props.modelValue, newValue => {
      internalValue.value = newValue;
    });
    const updateValue = newValue => {
      internalValue.value = newValue;
      emit('update:modelValue', newValue);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["tw", __props.horizontal ? 'flex-col' : 'flex-row'])
      }, [_createElementVNode("label", {
        class: _normalizeClass(__props.labelClass)
      }, [_createTextVNode(_toDisplayString(__props.label) + " ", 1), _withDirectives(_createElementVNode("span", _hoisted_1, "*", 512), [[_vShow, __props.isRequired]]), _withDirectives(_createVNode(LlTooltip, {
        text: __props.info,
        icon: "help"
      }, null, 8, ["text"]), [[_vShow, __props.info.length && __props.showInfo]])], 2), (_openBlock(), _createBlock(_resolveDynamicComponent(__props.isAutocomplete ? 'v-autocomplete' : 'v-select'), {
        "data-cy": __props.dataCy,
        modelValue: internalValue.value,
        items: __props.items,
        "item-title": __props.itemTitle,
        "item-value": __props.itemValue,
        "item-props": __props.itemProps,
        "menu-props": __props.menuProps,
        density: __props.density,
        "return-object": __props.returnObject,
        variant: __props.variant,
        class: _normalizeClass(__props.componentClass + (__props.invalid ? ' error' : '')),
        placeholder: __props.placeholder,
        "hide-details": __props.hideDetails,
        clearable: __props.clearable,
        disabled: __props.disabled,
        hint: __props.hint,
        "persistent-hint": __props.persistentHint,
        "onUpdate:modelValue": updateValue,
        rules: __props.rules,
        loading: __props.loading
      }, _createSlots({
        _: 2
      }, [_ctx.$slots.item ? {
        name: "item",
        fn: _withCtx(slotProps => [_renderSlot(_ctx.$slots, "item", _normalizeProps(_guardReactiveProps(slotProps)))]),
        key: "0"
      } : undefined, _ctx.$slots['append-item'] ? {
        name: "append-item",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "append-item")]),
        key: "1"
      } : undefined, _ctx.$slots['prepend-item'] ? {
        name: "prepend-item",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "prepend-item")]),
        key: "2"
      } : undefined, _ctx.$slots['no-data'] ? {
        name: "no-data",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "no-data")]),
        key: "3"
      } : undefined]), 1032, ["data-cy", "modelValue", "items", "item-title", "item-value", "item-props", "menu-props", "density", "return-object", "variant", "class", "placeholder", "hide-details", "clearable", "disabled", "hint", "persistent-hint", "rules", "loading"]))], 2);
    };
  }
};